export default function fxServiceManager(fetch, baseUrl) {
  return {
    getFxRatesConfig() {
      return fetch.get(`${baseUrl}/fx-rates-config`);
    },

    updateFxRatesConfig({ payload }) {
      return fetch.post(`${baseUrl}/fx-rates-config/update`, payload);
    },

    getVanceFxRates() {
      return fetch.get(`${baseUrl}/vance-fx-rates`);
    }
  };
}
